import React, { ReactNode } from "react";
import styles from "./css/DashboardCard.module.css";

interface DashboardProps {
  children?: ReactNode;
  tabContent?: ReactNode;
  middleTab?: boolean;
  className?: string;
  cardSize?: string;
}

export const DashboardCard: React.FC<DashboardProps> = ({
  children,
  tabContent,
  middleTab = true,
  className,
  cardSize
}) => {
  return (
    <div className={`${styles.cardContainer} `}>
      <div className={`${styles.cardWrapper} ${!middleTab ? styles.side: styles.middle} `}>
        {tabContent && <div className={`${styles.tab} ${middleTab? styles.middle: ''} ${className}`}>{tabContent}</div>}
        <div className={`${styles.card}  ${middleTab? styles.middle: ''} ${cardSize}`}>{children}</div>
      </div>
    </div>
  );
};
